import React, { Component } from 'react';
import { connect } from 'react-redux';
import Loadable from 'react-loadable';
import { bindActionCreators } from 'redux';

import InitialTemplate from './templates/mobile/mobileTemplate';
import Loader from '../reusable-components/misc/Loader';
import * as uspActions from './components/usp/uspActions';
import * as appActions from './appActions';
import * as trackingActions from './trackingActions';
import impressionTracking from './impressionTracking';

class Productpage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Template: InitialTemplate,
    };
  }

  componentDidMount() {
    this.props.fetchAndHandleUsps();
    window.addEventListener('resize', this.updateDimensions.bind(this));

    // tracking stuff
    const { data } = this.props;
    const productData = {
      id: this.props.product_id,
      min_price: data.prices.min_price,
      max_price: data.prices.max_price,
      rrp: data.prices.recommended_retail_price,
      currency: data.prices.currency,
      online: !data.cannot_buy_online,
      sizes: data.sizes,
    };
    // save the tracking data into redux so its nice and ready for different components
    this.props.saveTrackingData(productData);
    impressionTracking(this.props.data, productData);
  }

  componentDidUpdate(prevProps) {
    // all this seemignly awful repeat code to make sure it resizes nicely,
    // especially when rotating tablet - it has two different templates
    // ('tablet' for 768px and 'desktop for 1024)
    if (
      (prevProps.general.isMobile !== this.props.general.isMobile)
      || (prevProps.general.isTablet !== this.props.general.isTablet)
      || (prevProps.general.isSmallDesktop !== this.props.general.isSmallDesktop)
      || (prevProps.general.isBigDesktop !== this.props.general.isBigDesktop)
    ) {
      const template = this.determineTemplate();
      const LoadableBar = Loadable({
        loader: () => import(`./templates/${template}/${template}Template`),
        loading() {
          return <Loader hasOverlay className="full-screen" />;
        },
      });
      this.setState({
        Template: LoadableBar,
      });
    }
  }

  determineTemplate = () => {
    const { isMobile, isTablet } = this.props.general;
    let template = 'desktop';
    if (isMobile) template = 'mobile';
    if (isTablet) template = 'tablet';
    return template;
  }

  UNSAFE_componentWillMount() {
    const template = this.determineTemplate();
    if (template !== 'mobile') {
      const LoadableBar = Loadable({
        loader: () => import(`./templates/${template}/${template}Template`),
        loading() {
          return <Loader hasOverlay className="full-screen" />;
        },
      });
      this.setState({
        Template: LoadableBar,
      });
    }
  }

  updateDimensions() {
    this.props.SCREEN_RESIZE(window.innerWidth);
  }

  render() {
    const { Template } = this.state;
    return (
      <React.Fragment>
        {this.props.fetchingState &&
           <Loader hasOverlay className="full-screen" />
        }
        <Template />
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ app, general }) => {
  return {
    general,
    product_id: app.data.product_id,
    data: app.data,
    fetchingState: app.fetchingState,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    ...uspActions,
    ...appActions,
    ...trackingActions,
  }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Productpage);
